import { Group, Identifiable, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource } from "./types";

type ResourceResponse = {
  _embedded: {
    resources: LinkedResource<Identifiable<Resource>>[];
  };
};

function linkPlanzoneResourceGroup(httpClient: HttpClient) {
  return (
    group: LinkedResource<Identifiable<Group<Identifiable<Resource>>>>,
  ): Promise<Identifiable<Group<Identifiable<Resource>>>> =>
    httpClient
      .sendHttpRequest<ResourceResponse>({
        endpoint: group._links.resources.href,
        baseUrl: "",
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => ({
        ...group,
        resources: _embedded.resources,
      }));
}

export { linkPlanzoneResourceGroup };
